module.exports = {
  messages: {
    A11Y_LOGO: "Aller à la page d'accueil XING",
    A11Y_SETTINGS_DROPDOWN_LABEL: 'Modifier les paramètres',
    ACTIVE_LANGUAGE: 'Français',
    ACTIVITY_CENTER_CTA: 'Se connecter & enregistrer',
    ACTIVITY_CENTER_EMPTY_STATE_HEADLINE: 'Vos activités',
    ACTIVITY_CENTER_EMPTY_STATE_TEXT:
      'Vous y retrouverez ici vos activités et pourrez les enregistrer sur votre profil XING pour les consulter plus tard.',
    ACTIVITY_CENTER_FOOTER_TEXT:
      'Vos activités sont stockées temporairement pendant 14 jours maximum.',
    ACTIVITY_CENTER_HEADLINE: 'Vos activités',
    ACTIVITY_CENTER_NOTIFICATION_MESSAGE:
      "Vous avez enregistré une offre d'emploi.",
    ACTIVITY_CENTER_NOTIFICATION_OPEN: 'Afficher maintenant',
    ACTIVITY_CENTER_SAVED_JOBS_TITLE: "Offres d'emploi sélectionnées",
    ACTIVITY_CENTER_TEXT:
      'Vous retrouverez ici un aperçu de vos dernières activités. Avec un profil XING gratuit, vous pourrez les sauvegarder plus longtemps.',
    ARMSTRONG_DISCO_NAVIGATION_ICON_TEXT: 'Échange',
    BOTTOM_BAR_FIND_JOBS_LABEL: 'Trouver des offres',
    BOTTOM_BAR_INSIGHTS_LABEL: 'Détails',
    BOTTOM_BAR_NETWORK_LABEL: 'Réseau',
    BOTTOM_BAR_NOTIFICATIONS_LABEL: 'Notifications',
    BOTTOM_BAR_YOUR_JOBS_LABEL: "Vos offres d'emploi",
    BUTTON_TRY_AGAIN: 'Veuillez réessayer',
    FOOTER_LANGUAGES: 'Langue',
    FRAME_HEADER_SEARCH: 'Recherche',
    FRAME_HEADER_UPSELL_PREMIUM: 'Devenir Membre Premium',
    FRAME_HEADER_UPSELL_PROJOBS: 'Découvrir ProJobs',
    HEADER_SKIP_NAVIGATION: 'Sauter la navigation',
    MAINNAV_ACTIVITY_CENTER: 'Your activity',
    MAINNAV_BUSINESS_SOLUTIONS: 'Business solutions',
    MAINNAV_BUSINESS_SOLUTIONS_ADVERTISING: 'Annoncer sur XING',
    MAINNAV_BUSINESS_SOLUTIONS_RECRUITING: 'Recruiting with XING',
    MAINNAV_COMPANIES: 'Companies',
    MAINNAV_INSIGHTS: 'Détails',
    MAINNAV_JOBS_FIND: 'Trouver des offres',
    MAINNAV_LOGIN: 'Log in',
    MAINNAV_NETWORK: 'Réseau',
    MALT_FOOTER_COPYRIGHT_API: '© {siteoperator}  | Tous droits réservés',
    MEMENU_FOLLOWING_LABEL: 'Abonné(e)',
    MEMENU_HELP_LABEL: 'Aide',
    MEMENU_JOB_ADS_LABEL: "Gérer les offres d'emploi",
    MEMENU_JOB_PREFERENCES_LABEL: 'Attentes professionnelles',
    MEMENU_MY_POSTS_LABEL: 'Vos publications',
    MEMENU_PREMIUM_FOR_BASIC_USER_LABEL: 'Devenir Membre Premium',
    MEMENU_PREMIUM_LABEL: 'Premium',
    MEMENU_PROBUSINESS_LABEL: 'ProBusiness',
    MEMENU_PROFILE_LABEL: 'Profil',
    MEMENU_PROJOBS_FOR_BASIC_USER_LABEL: 'Opter pour ProJobs',
    MEMENU_PROJOBS_LABEL: 'ProJobs',
    MEMENU_SETTINGS_LABEL: 'Paramètres',
    NOTIFICATION_CENTER_LINK: 'Notifications',
    SEARCH_DROPDOWN_COMPANIES: 'Entreprises',
    SEARCH_DROPDOWN_JOBS: "Offres d'emploi",
    SEARCH_DROPDOWN_MEMBERS: 'Membres',
    SEARCH_DROPDOWN_NEWS: "Sources d'actualités",
    USER_FLAG_BUTTON_ARIA_LABEL: "Badge de l'abonnement {type}",
    VERTICAL_NAV_BUSINESS_SOLUTIONS_LABEL: 'Solutions professionnelles',
    VERTICAL_NAV_BUSINESS_SOLUTIONS_SHORT_LABEL: 'Business',
    VERTICAL_NAV_FIND_JOBS_LABEL: 'Trouver des offres',
    VERTICAL_NAV_FOLLOWING_LABEL: 'Abonné(e)',
    VERTICAL_NAV_INSIGHTS_LABEL: 'Détails',
    VERTICAL_NAV_JOB_PREFERENCES_LABEL: 'Attentes professionnelles',
    VERTICAL_NAV_MESSAGES_LABEL: 'Messages',
    VERTICAL_NAV_MY_POSTS_LABEL: 'Vos publications',
    VERTICAL_NAV_NETWORK_LABEL: 'Votre réseau',
    VERTICAL_NAV_NETWORK_SHORT_LABEL: 'Réseau',
    VERTICAL_NAV_PREMIUM_FOR_BASIC_USER_LABEL: 'Devenir Membre Premium',
    VERTICAL_NAV_PREMIUM_LABEL: 'Premium',
    VERTICAL_NAV_PREMIUM_SHORT_LABEL: 'Premium',
    VERTICAL_NAV_PROBUSINESS_LABEL: 'ProBusiness',
    VERTICAL_NAV_PROFILE_LABEL: 'Profil',
    VERTICAL_NAV_PROJOBS_FOR_BASIC_USER_LABEL: 'Opter pour ProJobs',
    VERTICAL_NAV_PROJOBS_LABEL: 'ProJobs',
    VERTICAL_NAV_YOUR_JOBS_LABEL: "Vos offres d'emploi",
    VERTICAL_NAVIGATION_COMPANIES: 'Entreprises',
    VERTICAL_NAVIGATION_FOOTER_ADVERTISE: 'Annoncer sur XING',
    VERTICAL_NAVIGATION_FOOTER_ANDROID: 'Android',
    VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN: 'Éditeur de lettre de motivation',
    VERTICAL_NAVIGATION_FOOTER_APP_GALLERY: 'Applications mobiles et de bureau',
    VERTICAL_NAVIGATION_FOOTER_APPS: 'Applications',
    VERTICAL_NAVIGATION_FOOTER_BEWERBUNG: 'Conseils pour votre candidature',
    VERTICAL_NAVIGATION_FOOTER_CAREER: 'Carrière',
    VERTICAL_NAVIGATION_FOOTER_CAREER_GUIDE: 'Guide de carrière',
    VERTICAL_NAVIGATION_FOOTER_COACHES: 'Coaches + Trainer',
    VERTICAL_NAVIGATION_FOOTER_COMPANIES: 'Entreprises',
    VERTICAL_NAVIGATION_FOOTER_COMPANY: 'Entreprise',
    VERTICAL_NAVIGATION_FOOTER_DEVBLOG: 'Devblog',
    VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER: 'Freelancer verwalten',
    VERTICAL_NAVIGATION_FOOTER_HELP: 'Aide & Contact',
    VERTICAL_NAVIGATION_FOOTER_IMPRINT: 'À propos de ce site',
    VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS: 'Relations investisseurs',
    VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD: 'iPhone & iPad',
    VERTICAL_NAVIGATION_FOOTER_JOBS_DIRECTORY: "Répertoire des offres d'emploi",
    VERTICAL_NAVIGATION_FOOTER_KUNUNU: 'Employeurs',
    VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF: 'Éditeur de CV',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_ADMINISTRATION:
      'Gérer les abonnements',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_CANCELLATION: "Résilier l'abonnement",
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS: 'Abonnements',
    VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE:
      'NWX – Neues zur Zukunft der Arbeit',
    VERTICAL_NAVIGATION_FOOTER_NEWWORKSE: 'New Work SE',
    VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY: 'Annuaire des membres',
    VERTICAL_NAVIGATION_FOOTER_PRAKTIKUM_GUIDE: 'Praktikum-Guide',
    VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_FOOTER_PRESS: 'Presse',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY: 'Confidentialité sur XING',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY: 'Déclaration de confidentialité',
    VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_FOOTER_RESOURCES: 'Ressources',
    VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER: 'Recruter sur XING',
    VERTICAL_NAVIGATION_FOOTER_TANDC: "Conditions d'utilisation",
    VERTICAL_NAVIGATION_FOOTER_XAS: 'Post an ad',
    VERTICAL_NAVIGATION_FOOTER_XING_NEWS: 'Actualités XING',
    VERTICAL_NAVIGATION_FOOTER_YOUR_XING: 'Rubriques principales',
    VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR:
      "Gérer les profils d'entreprise",
    VERTICAL_NAVIGATION_HEADER_HELP: 'Aide',
    VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS: "Gérer les offres d'emploi",
    VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS: 'AdManager',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE:
      'Mon profil de coach / trainer',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT: 'Fermer la session',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_MEMBERSHIPS_INVOICES:
      'Abonnements & Factures ',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS: 'Paramètres',
    VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN: 'LicenceManager',
    VERTICAL_NAVIGATION_HEADER_XTM: 'TalentManager',
    VERTICAL_NAVIGATION_MESSAGES: 'Messages',
    X_UI_HEADER_REGISTER: 'Inscription',
    X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK: 'Connexion',
    XDS_FLAG_AMBASSADOR_DIVERSE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_FEMALE: 'Ambassadrice',
    XDS_FLAG_AMBASSADOR_MALE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_NEUTRAL: 'Ambassador',
    XDS_FLAG_BASIC_DIVERSE: 'Standard',
    XDS_FLAG_BASIC_FEMALE: 'Standard',
    XDS_FLAG_BASIC_MALE: 'Standard',
    XDS_FLAG_BASIC_NEUTRAL: 'Standard',
    XDS_FLAG_BETA_DIVERSE: 'Bêta',
    XDS_FLAG_BETA_FEMALE: 'Bêta',
    XDS_FLAG_BETA_MALE: 'Bêta',
    XDS_FLAG_BETA_NEUTRAL: 'Bêta',
    XDS_FLAG_INSIDER_DIVERSE: 'Expert(e)',
    XDS_FLAG_INSIDER_FEMALE: 'Experte',
    XDS_FLAG_INSIDER_MALE: 'Expert',
    XDS_FLAG_INSIDER_NEUTRAL: 'Expert',
    XDS_FLAG_MODERATOR_DIVERSE: 'Modérateur',
    XDS_FLAG_MODERATOR_FEMALE: 'Modératrice',
    XDS_FLAG_MODERATOR_MALE: 'Modérateur',
    XDS_FLAG_MODERATOR_NEUTRAL: 'Modérateur',
    XDS_FLAG_NEW_DIVERSE: 'Nouveau',
    XDS_FLAG_NEW_FEMALE: 'Nouveau',
    XDS_FLAG_NEW_MALE: 'Nouveau',
    XDS_FLAG_NEW_NEUTRAL: 'Nouveau',
    XDS_FLAG_PREMIUM_DIVERSE: 'Premium',
    XDS_FLAG_PREMIUM_FEMALE: 'Premium',
    XDS_FLAG_PREMIUM_MALE: 'Premium',
    XDS_FLAG_PREMIUM_NEUTRAL: 'Premium',
    XDS_FLAG_PROBUSINESS_DIVERSE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_FEMALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_MALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_NEUTRAL: 'ProBusiness',
    XDS_FLAG_PROCOACH_DIVERSE: 'ProCoach',
    XDS_FLAG_PROCOACH_FEMALE: 'ProCoach',
    XDS_FLAG_PROCOACH_MALE: 'ProCoach',
    XDS_FLAG_PROCOACH_NEUTRAL: 'ProCoach',
    XDS_FLAG_PROJOBS_DIVERSE: 'ProJobs',
    XDS_FLAG_PROJOBS_FEMALE: 'ProJobs',
    XDS_FLAG_PROJOBS_MALE: 'ProJobs',
    XDS_FLAG_PROJOBS_NEUTRAL: 'ProJobs',
    XDS_FLAG_PROTRAINER_DIVERSE: 'ProTrainx',
    XDS_FLAG_PROTRAINER_FEMALE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_MALE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_NEUTRAL: 'ProTrainer',
  },
};
